module.exports = __webpack_public_path__ + "img/fi-rr-check.3f0953ec.svg";